import type { MaterialCatalogItem } from './api';

export type CatalogMaterial = MaterialCatalogItem;

export const GROUP_ORDER = ['metal', 'precious_gemstone', 'semi_precious_gemstone', 'mineral'] as const;

export const GROUP_LABELS: Record<string, string> = {
  metal: 'Metals',
  precious_gemstone: 'Precious gemstones',
  semi_precious_gemstone: 'Semi-precious gemstones',
  mineral: 'Minerals',
};

export function haulCategoryKey(m: Pick<CatalogMaterial, 'kind' | 'haulCategory' | 'gemTier'>): string {
  if (m.kind === 'mineral') return 'mineral';
  if (m.haulCategory) return m.haulCategory;
  if (m.kind === 'metal') return 'metal';
  if (m.gemTier === 'precious') return 'precious_gemstone';
  return 'semi_precious_gemstone';
}

export function haulCategoryLabel(m: Pick<CatalogMaterial, 'kind' | 'haulCategory' | 'gemTier'>): string {
  const key = haulCategoryKey(m);
  return GROUP_LABELS[key] ?? key.replace(/_/g, ' ');
}

export function groupMaterials(materials: CatalogMaterial[]): Map<string, CatalogMaterial[]> {
  const groups = new Map<string, CatalogMaterial[]>();
  for (const m of materials) {
    const key = haulCategoryKey(m);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key)!.push(m);
  }
  for (const items of groups.values()) {
    items.sort((a, b) => a.displayName.localeCompare(b.displayName));
  }
  return groups;
}

export function orderedGroupEntries(groups: Map<string, CatalogMaterial[]>) {
  const ordered: Array<[string, CatalogMaterial[]]> = [];
  for (const key of GROUP_ORDER) {
    const items = groups.get(key);
    if (items?.length) ordered.push([key, items]);
  }
  for (const [key, items] of groups) {
    if (!GROUP_ORDER.includes(key as (typeof GROUP_ORDER)[number]) && items.length) {
      ordered.push([key, items]);
    }
  }
  return ordered;
}
